import {createTheme} from '@mui/material/styles'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import {PUBLIC_URL} from '../../config/env'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2C384E',
    },
    secondary: {
      main: '#b68a35',
      contrastText: '#fff',
    },
    success: {
      main: '#008000',
    },
    text: {
      primary: '#626261',
    },
    background: {
      default: '#f2f2f2',
    },
  },
  components: {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
    },
    MuiButtonGroup: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiAppBar: {
      defaultProps: {
        elevation: 0,
      },
    },
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Changa-Bold';
          src: url(${PUBLIC_URL}/fonts/Changa/Changa-Bold.ttf);
        }
      `,
    },
  },
})

declare module '@mui/material' {
  interface Palette {}

  interface PaletteOptions {}

  interface AppBarPropsColorOverrides {}
}
